import cn from 'classnames';
import { ImageElement } from 'modules/product-details/types';
import { m } from 'motion/react';

interface Props {
  images: ImageElement[];
  selectedGalleryItemIndex: number;
  onClick: (index: number) => void;
}

const CarouselSelector: React.FC<Props> = ({
  images,
  selectedGalleryItemIndex,
  onClick,
}) => {
  if (images.length === 1) return null;

  return (
    <div className="flex items-center justify-center gap-[6px] lg:hidden">
      {images.map((image, index) => (
        <m.button
          animate={{
            backgroundColor:
              selectedGalleryItemIndex === index ? '#19335A' : '#B4BDCC',
            width: selectedGalleryItemIndex === index ? 18 : 6,
          }}
          className={cn('h-[6px] rounded-full focus:outline-hidden')}
          key={index}
          onClick={() => onClick(index)}
          transition={{
            damping: 20,
            duration: 0.2,
            stiffness: 500,
            type: 'spring',
          }}
        />
      ))}
    </div>
  );
};

export default CarouselSelector;
